import './Select.MenuItem.scss.js';
import React__default, { useRef, useEffect } from 'react';
import { classnames } from '../../../utils/classnames.js';

var MenuItem = function MenuItem(_ref) {
  var children = _ref.children,
      autoFocus = _ref.autoFocus,
      option = _ref.option,
      active = _ref.active,
      onFocus = _ref.onFocus;
  var ref = useRef(null);
  useEffect(function () {
    var _a;

    if (autoFocus) {
      (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, [autoFocus]);
  return /*#__PURE__*/React__default.createElement("li", {
    ref: ref,
    tabIndex: 0,
    "data-testid": "rf-select__list-element-".concat(option.value),
    className: classnames('rf-select-menu-item', option.disabled && 'rf-select-menu-item--disabled', active && 'rf-select-menu-item--active'),
    onFocus: onFocus,
    "aria-disabled": option.disabled ? 'true' : undefined,
    "data-v-6e52f9c7": ""
  }, children);
};

export { MenuItem as default };
